export enum Events {
  INITIALIZED = 'ima.plugin.analytic.initialized',
  LOADED = 'ima.plugin.analytic.loaded',
}
